import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "view-stock",
  class: "stock-view-shell"
}
const _hoisted_2 = { class: "container-fluid stock-view-main" }
const _hoisted_3 = {
  key: 0,
  class: "title stock-hero"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-12 col-xl-10" }
const _hoisted_6 = { class: "d-flex align-items-center ms-4 mt-4" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = { class: "ms-3 stock-price-cluster" }
const _hoisted_9 = { class: "current-price mb-0" }
const _hoisted_10 = { class: "last-updated" }
const _hoisted_11 = { class: "stock-info" }
const _hoisted_12 = { class: "stock-details" }
const _hoisted_13 = { class: "price-change" }
const _hoisted_14 = { class: "total-change" }
const _hoisted_15 = { class: "col-sm-12 col-xl-2" }
const _hoisted_16 = { class: "d-flex align-items-center ms-4 mt-4 stock-external-links" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 1,
  class: "row"
}
const _hoisted_20 = { class: "col-sm-12 col-xl-10" }
const _hoisted_21 = { class: "summary-box portfolio-summary" }
const _hoisted_22 = { class: "list-group stock-view-summary" }
const _hoisted_23 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_24 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_35 = { class: "value" }
const _hoisted_36 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_39 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_40 = { class: "value" }
const _hoisted_41 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_44 = { class: "value" }
const _hoisted_45 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "d-flex align-items-center ms-4 mt-4 platform-title-row" }
const _hoisted_50 = { class: "flex-shrink-0" }
const _hoisted_51 = { class: "col-sm-12 col-xl-7" }
const _hoisted_52 = { class: "summary-box platform-summary" }
const _hoisted_53 = { class: "list-group stock-view-summary" }
const _hoisted_54 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_55 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_56 = { class: "value" }
const _hoisted_57 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_58 = { class: "value" }
const _hoisted_59 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_60 = { class: "value" }
const _hoisted_61 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_62 = { class: "value" }
const _hoisted_63 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_64 = { class: "value" }
const _hoisted_65 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_66 = { class: "value" }
const _hoisted_67 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_68 = { class: "value" }
const _hoisted_69 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_70 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_71 = { class: "value" }
const _hoisted_72 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_73 = { class: "value" }
const _hoisted_74 = { class: "list-group-item bg-transparent flex-space-between" }
const _hoisted_75 = { class: "value" }
const _hoisted_76 = {
  key: 0,
  class: "col-sm-12 col-xl-5"
}
const _hoisted_77 = { class: "tracker-panel h-100 p-4" }
const _hoisted_78 = { class: "mb-4" }
const _hoisted_79 = { class: "list-group" }
const _hoisted_80 = {
  key: 2,
  class: "row"
}
const _hoisted_81 = { class: "col-sm-12 col-xl-10 chart-grid-column" }
const _hoisted_82 = { class: "stock-chart-panel" }
const _hoisted_83 = { class: "stock-chart-filter-bar" }
const _hoisted_84 = { class: "stock-chart-filter-row stock-chart-filter-row-top" }
const _hoisted_85 = { class: "stock-chart-filter-group preset-group" }
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { class: "pill-label" }
const _hoisted_88 = {
  key: 0,
  class: "pill-value"
}
const _hoisted_89 = { class: "stock-chart-filter-group custom-preset-group" }
const _hoisted_90 = { value: "THIS_YEAR" }
const _hoisted_91 = { value: "LAST_YEAR" }
const _hoisted_92 = { class: "stock-chart-filter-row stock-chart-filter-row-bottom" }
const _hoisted_93 = { class: "stock-chart-filter-group custom-range-group" }
const _hoisted_94 = { class: "stock-chart-filter-group custom-range-group" }
const _hoisted_95 = { class: "stock-chart-filter-group platform-select-group" }
const _hoisted_96 = { class: "stock-chart-filter-group reset-group" }
const _hoisted_97 = { class: "container-fluid pt-4 px-4 stock-table-wrap" }
const _hoisted_98 = { class: "stock-data-panel text-center rounded p-4" }
const _hoisted_99 = { class: "stock-data-panel-inner text-center rounded" }
const _hoisted_100 = {
  key: 0,
  class: "stock-section-heading d-flex align-items-center justify-content-between mb-0 p-1"
}
const _hoisted_101 = { class: "data-table" }
const _hoisted_102 = { class: "table-responsive" }
const _hoisted_103 = {
  key: 0,
  class: "container-fluid pt-4 px-4"
}
const _hoisted_104 = { class: "stock-data-panel text-center rounded p-4" }
const _hoisted_105 = { class: "stock-data-panel-inner text-center rounded" }
const _hoisted_106 = { class: "stock-section-heading d-flex align-items-center justify-content-between mb-0 p-1" }
const _hoisted_107 = { class: "mb-0 p-1" }
const _hoisted_108 = { class: "data-table" }
const _hoisted_109 = { class: "table-responsive" }
const _hoisted_110 = {
  key: 0,
  class: "container-fluid pt-4 px-4"
}
const _hoisted_111 = { class: "stock-data-panel text-center rounded p-4" }
const _hoisted_112 = { class: "stock-data-panel-inner text-center rounded" }
const _hoisted_113 = { class: "stock-section-heading d-flex align-items-center justify-content-between mb-0 p-1" }
const _hoisted_114 = { class: "mb-0 p-1" }
const _hoisted_115 = { class: "data-table" }
const _hoisted_116 = { class: "table-responsive" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_call = _resolveComponent("call")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_SummaryChart = _resolveComponent("SummaryChart")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return ($data.stock)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (this.stock.first_stock && this.stock.first_stock.code)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h2", _hoisted_7, _toDisplayString(this.$helper.formatTitle(this.stock.first_stock.name)), 1),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(this.$helper.formatPrice(
                      this.stock.first_stock.market_price
                    )), 1),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(this.$helper.formatDate(
                    this.stock.first_stock.updated_at,
                    true
                  )), 1)
                      ]),
                      (this.stock.first_history)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["current-price stock-change-chip m-1", {
                  'positive-status': this.stock.first_history.market_change > 0,
                  'negative-status': this.stock.first_history.market_change < 0,
                }])
                          }, [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: [
                      'fas',
                      this.stock.first_history.market_change < 0
                        ? 'circle-down'
                        : 'circle-up',
                    ]
                              }, null, 8, ["icon"]),
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, _toDisplayString(this.$helper.formatPrice(
                          this.stock.first_history.market_change
                        )) + " (" + _toDisplayString(this.$helper.formatPercentage(
                          this.stock.first_history.market_change_percent / 100
                        )) + ") ", 1),
                                _createElementVNode("div", _hoisted_14, _toDisplayString(this.$helper.formatPrice(
                          this.stock.first_history.market_change *
                            this.stock.total.qty
                        )), 1)
                              ])
                            ])
                          ], 2))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("a", {
                        href: $options.getScreenerUrl(),
                        target: "_blank",
                        class: "market-link"
                      }, [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("img", {
                          class: "flex-shrink-0",
                          src: "/screener.png",
                          style: {"width":"40px","height":"40px"}
                        }, null, -1)
                      ]))], 8, _hoisted_17),
                      _createElementVNode("a", {
                        href: $options.getMoneycontrolUrl(),
                        target: "_blank",
                        class: "market-link"
                      }, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("img", {
                          class: "flex-shrink-0",
                          src: "/moneycontrol.png",
                          style: {"width":"40px","height":"40px"}
                        }, null, -1)
                      ]))], 8, _hoisted_18)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (this.stock.first_stock && this.stock.first_stock.code)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("ul", _hoisted_22, [
                      _createElementVNode("li", _hoisted_23, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "name" }, "P/L", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["value", this.stock.total.profit_loss >= 0 ? 'text-success' : 'text-error'])
                        }, _toDisplayString(this.$helper.formatPrice(this.stock.total.profit_loss)) + " / " + _toDisplayString(this.$helper.formatPercentage(
                      this.stock.total.profit_loss / this.stock.total.investment
                    )), 3)
                      ]),
                      _createElementVNode("li", _hoisted_24, [
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "name" }, "Total Investment", -1)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(this.$helper.formatPrice(this.stock.total.investment)), 1)
                      ]),
                      _createElementVNode("li", _hoisted_26, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "name" }, "Current Value", -1)),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(this.$helper.formatPrice(this.stock.total.current_value)), 1)
                      ]),
                      _createElementVNode("li", _hoisted_28, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "name" }, "QTY", -1)),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(this.stock.total.qty), 1)
                      ]),
                      _createElementVNode("li", _hoisted_30, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "name" }, "Average Price", -1)),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(this.$helper.formatPrice(this.stock.total.avg_price)), 1)
                      ]),
                      _createElementVNode("li", _hoisted_32, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "name" }, "Dividend", -1)),
                        _createElementVNode("span", _hoisted_33, _toDisplayString(this.$helper.formatPrice(this.stock.total.dividend)), 1)
                      ]),
                      _createElementVNode("li", _hoisted_34, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "name" }, "Total Buy", -1)),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(this.$helper.formatPrice(
                    this.stock.total.transaction.total_buy
                  )), 1)
                      ]),
                      _createElementVNode("li", _hoisted_36, [
                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "name" }, "Total Sell", -1)),
                        _createElementVNode("span", _hoisted_37, _toDisplayString(this.$helper.formatPrice(
                    this.stock.total.transaction.total_sell
                  )), 1)
                      ]),
                      _createElementVNode("li", _hoisted_38, [
                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "name" }, "Sell (P/L)", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["value", this.stock.total.transaction.total_sell_profit >= 0 ? 'text-success' : 'text-error'])
                        }, _toDisplayString(this.$helper.formatPrice(
                    this.stock.total.transaction.total_sell_profit
                  )), 3)
                      ]),
                      _createElementVNode("li", _hoisted_39, [
                        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "name" }, "Total Day From Purchase", -1)),
                        _createElementVNode("span", _hoisted_40, _toDisplayString(this.getTotalDayFromPurchase(
                    this.stock.first_stock.perches_date
                  )), 1)
                      ]),
                      _createElementVNode("li", _hoisted_41, [
                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "name" }, "52 Week Low", -1)),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(this.$helper.formatPrice(
                    this.stock.first_stock.fifty_two_week_low
                  )), 1)
                      ]),
                      _createElementVNode("li", _hoisted_43, [
                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "name" }, "52 Week High", -1)),
                        _createElementVNode("span", _hoisted_44, _toDisplayString(this.$helper.formatPrice(
                    this.stock.first_stock.fifty_two_week_high
                  )), 1)
                      ]),
                      _createElementVNode("li", _hoisted_45, [
                        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "name" }, "Percentage To Sell", -1)),
                        _createElementVNode("span", _hoisted_46, _toDisplayString(this.$helper.formatPercentage(
                    this.stock.total.percentage_to_sell / 100
                  )), 1)
                      ]),
                      _createElementVNode("li", _hoisted_47, [
                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "name" }, "Qty To Sell", -1)),
                        _createElementVNode("span", _hoisted_48, _toDisplayString(this.stock.total.qty_to_sell), 1)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewStockPlatformWise, (stock, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `platform-${index}`,
              class: "row platform-position"
            }, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("h4", _hoisted_50, _toDisplayString(this.platformListOption[stock.platform_id]), 1)
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("ul", _hoisted_53, [
                    _createElementVNode("li", _hoisted_54, [
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "name" }, "P/L", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["value", this.stock.profit_loss[stock.platform_id] >= 0 ? 'text-success' : 'text-error'])
                      }, _toDisplayString(this.$helper.formatPL(
                        this.stock.profit_loss[stock.platform_id],
                        (this.stock.profit_loss[stock.platform_id] /
                          stock.investment) *
                          100
                      )), 3)
                    ]),
                    _createElementVNode("li", _hoisted_55, [
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "name" }, "Investment", -1)),
                      _createElementVNode("span", _hoisted_56, _toDisplayString(this.$helper.formatPrice(stock.investment)), 1)
                    ]),
                    _createElementVNode("li", _hoisted_57, [
                      _cache[27] || (_cache[27] = _createElementVNode("span", { class: "name" }, "Current Value", -1)),
                      _createElementVNode("span", _hoisted_58, _toDisplayString(this.$helper.formatPrice(stock.market_price * stock.qty)), 1)
                    ]),
                    _createElementVNode("li", _hoisted_59, [
                      _cache[28] || (_cache[28] = _createElementVNode("span", { class: "name" }, "QTY", -1)),
                      _createElementVNode("span", _hoisted_60, _toDisplayString(stock.qty), 1)
                    ]),
                    _createElementVNode("li", _hoisted_61, [
                      _cache[29] || (_cache[29] = _createElementVNode("span", { class: "name" }, "Average Price", -1)),
                      _createElementVNode("span", _hoisted_62, _toDisplayString(this.$helper.formatPrice(stock.avg_price)), 1)
                    ]),
                    _createElementVNode("li", _hoisted_63, [
                      _cache[30] || (_cache[30] = _createElementVNode("span", { class: "name" }, "Dividend", -1)),
                      _createElementVNode("span", _hoisted_64, _toDisplayString(this.$helper.formatPrice(
                      this.stock.dividend[stock.platform_id]
                    )), 1)
                    ]),
                    _createElementVNode("li", _hoisted_65, [
                      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "name" }, "Total Buy", -1)),
                      _createElementVNode("span", _hoisted_66, _toDisplayString(this.$helper.formatPrice(
                      this.stock.transaction.total_buy[stock.platform_id]
                    )), 1)
                    ]),
                    _createElementVNode("li", _hoisted_67, [
                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "name" }, "Total Sell", -1)),
                      _createElementVNode("span", _hoisted_68, _toDisplayString(this.$helper.formatPrice(
                      this.stock.transaction.total_sell[stock.platform_id]
                    )), 1)
                    ]),
                    _createElementVNode("li", _hoisted_69, [
                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "name" }, "Sell (P/L)", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["value", this.stock.transaction.total_sell_profit[stock.platform_id] >= 0 ? 'text-success' : 'text-error'])
                      }, _toDisplayString(this.$helper.formatPrice(
                      this.stock.transaction.total_sell_profit[
                        stock.platform_id
                      ]
                    )), 3)
                    ]),
                    _createElementVNode("li", _hoisted_70, [
                      _cache[34] || (_cache[34] = _createElementVNode("span", { class: "name" }, "Total Day(P)", -1)),
                      _createElementVNode("span", _hoisted_71, _toDisplayString(this.getTotalDayFromPurchase(stock.perches_date)), 1)
                    ]),
                    _createElementVNode("li", _hoisted_72, [
                      _cache[35] || (_cache[35] = _createElementVNode("span", { class: "name" }, "Percentage To Sell", -1)),
                      _createElementVNode("span", _hoisted_73, _toDisplayString(this.$helper.formatPercentage(
                      stock.percentage_to_sell / 100
                    )), 1)
                    ]),
                    _createElementVNode("li", _hoisted_74, [
                      _cache[36] || (_cache[36] = _createElementVNode("span", { class: "name" }, "Qty To Sell", -1)),
                      _createElementVNode("span", _hoisted_75, _toDisplayString(stock.qty_to_sell), 1)
                    ])
                  ])
                ])
              ]),
              (this.tracker.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("h6", _hoisted_78, [
                        _createTextVNode(" Tracker - " + _toDisplayString(this.platformListOption[stock.platform_id]) + " - ", 1),
                        _createElementVNode("span", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.reloadTracker()))
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'arrows-rotate'] })
                        ])
                      ]),
                      _createElementVNode("ul", _hoisted_79, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.tracker.filter(
                    (tracker) =>
                      tracker.rule.includes(stock.stock_id) &&
                      tracker.type_id == 1
                  ), (_tracker, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "list-group-item bg-transparent",
                            key: index
                          }, _toDisplayString(_tracker.name), 1))
                        }), 128))
                      ]),
                      _createVNode(_component_call, {
                        rows: this.tracker,
                        stockId: stock.stock_id,
                        name: $options.getTrackerName(stock)
                      }, null, 8, ["rows", "stockId", "name"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          ($data.fullHistoryData.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.chartFilterPresetOptions, (preset) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: preset.value,
                              type: "button",
                              class: _normalizeClass(["chart-filter-pill", [
                      { active: $data.chartFilters.selectedPreset === preset.value },
                      preset.performanceClass
                    ]]),
                              onClick: ($event: any) => ($options.applyChartPreset(preset.value))
                            }, [
                              _createElementVNode("span", _hoisted_87, _toDisplayString(preset.label), 1),
                              (preset.value && preset.performanceText)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(preset.performanceText), 1))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_86))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          _cache[38] || (_cache[38] = _createElementVNode("label", { class: "chart-filter-label" }, "Range", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.chartFilters.customRangePreset) = $event)),
                            class: "chart-filter-select",
                            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.applyCustomRangePreset && $options.applyCustomRangePreset(...args)))
                          }, [
                            _cache[37] || (_cache[37] = _createStaticVNode("<option value=\"\" data-v-78e8a348>Custom Range</option><option value=\"TODAY\" data-v-78e8a348>Today</option><option value=\"YESTERDAY\" data-v-78e8a348>Yesterday</option><option value=\"7_DAYS\" data-v-78e8a348>Last 7 Days</option><option value=\"15_DAYS\" data-v-78e8a348>Last 15 Days</option><option value=\"30_DAYS\" data-v-78e8a348>Last 30 Days</option><option value=\"90_DAYS\" data-v-78e8a348>Last 90 Days</option><option value=\"THIS_WEEK\" data-v-78e8a348>This Week</option><option value=\"LAST_WEEK\" data-v-78e8a348>Last Week</option><option value=\"THIS_MONTH\" data-v-78e8a348>This Month</option><option value=\"LAST_MONTH\" data-v-78e8a348>Last Month</option><option value=\"3_MONTHS\" data-v-78e8a348>Last 3 Months</option><option value=\"6_MONTHS\" data-v-78e8a348>Last 6 Months</option>", 13)),
                            _createElementVNode("option", _hoisted_90, "This Year (" + _toDisplayString(new Date().getFullYear()) + ")", 1),
                            _createElementVNode("option", _hoisted_91, "Last Year (" + _toDisplayString(new Date().getFullYear() - 1) + ")", 1)
                          ], 544), [
                            [_vModelSelect, $data.chartFilters.customRangePreset]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _cache[39] || (_cache[39] = _createElementVNode("label", { class: "chart-filter-label" }, "From", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.chartFilters.fromDate) = $event)),
                            type: "date",
                            class: "chart-filter-input",
                            onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.handleManualDateInput && $options.handleManualDateInput(...args)))
                          }, null, 544), [
                            [_vModelText, $data.chartFilters.fromDate]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          _cache[40] || (_cache[40] = _createElementVNode("label", { class: "chart-filter-label" }, "To", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.chartFilters.toDate) = $event)),
                            type: "date",
                            class: "chart-filter-input",
                            onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.handleManualDateInput && $options.handleManualDateInput(...args)))
                          }, null, 544), [
                            [_vModelText, $data.chartFilters.toDate]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_95, [
                          _cache[41] || (_cache[41] = _createElementVNode("label", { class: "chart-filter-label" }, "Platform", -1)),
                          _createVNode(_component_v_select, {
                            modelValue: $data.chartFilters.platformIds,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.chartFilters.platformIds) = $event)),
                            items: $options.chartPlatformOptions,
                            "item-title": "label",
                            "item-value": "value",
                            variant: "outlined",
                            density: "compact",
                            multiple: "",
                            clearable: "",
                            "hide-details": ""
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _createElementVNode("div", _hoisted_96, [
                          _cache[42] || (_cache[42] = _createElementVNode("label", { class: "chart-filter-label chart-filter-label-hidden" }, "Reset", -1)),
                          _createElementVNode("button", {
                            type: "button",
                            class: "chart-filter-reset",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($options.resetChartFilters && $options.resetChartFilters(...args)))
                          }, " Reset ")
                        ])
                      ])
                    ]),
                    ($data.chartTrend.hasData)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["stock-trend-summary", $data.chartTrend.directionClass])
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fas', $data.chartTrend.isUp ? 'arrow-trend-up' : $data.chartTrend.isDown ? 'arrow-trend-down' : 'minus']
                          }, null, 8, ["icon"]),
                          _createElementVNode("span", null, _toDisplayString($data.chartTrend.label) + " " + _toDisplayString(this.$helper.formatPrice($data.chartTrend.absoluteChange)) + " (" + _toDisplayString(this.$helper.formatPercentage($data.chartTrend.percentageChange / 100)) + ") ", 1)
                        ], 2))
                      : _createCommentVNode("", true),
                    _createVNode(_component_SummaryChart, {
                      rawData: this.chart.data,
                      chartOptions: this.chart.options
                    }, null, 8, ["rawData", "chartOptions"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_97, [
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              ($data.history)
                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [...(_cache[43] || (_cache[43] = [
                    _createElementVNode("div", { class: "mb-0 p-1" }, "History", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("div", _hoisted_102, [
                  _createVNode(_component_v_data_table, {
                    headers: this.history.headers,
                    items: $data.history.data,
                    "items-per-page-options": [10, 15, 20, 30, 50, 100, 200],
                    "items-per-page": 5,
                    "sort-by": [{ key: 'created_at', order: 'desc' }],
                    class: "stock-data-table table text-start align-middle table-hover mb-0"
                  }, {
                    [`item.created_at`]: _withCtx(({ item }) => [
                      _createElementVNode("span", null, _toDisplayString(this.$helper.formatDate(item.created_at)), 1)
                    ]),
                    [`item.market_change`]: _withCtx(({ item }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(Number(item.market_change) >= 0 ? 'text-success' : 'text-error')
                      }, _toDisplayString(item.market_change), 3)
                    ]),
                    [`item.market_change_percent`]: _withCtx(({ item }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(Number(item.market_change_percent) >= 0 ? 'text-success' : 'text-error')
                      }, _toDisplayString(item.market_change_percent), 3)
                    ]),
                    _: 2
                  }, 1032, ["headers", "items"])
                ])
              ])
            ])
          ])
        ]),
        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "d-flex align-items-center ms-4 mt-4" }, [
            _createElementVNode("h4", { class: "flex-shrink-0" }, "Dividend")
          ])
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewStockPlatformWise, (stock, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `dividend-${index}`
          }, [
            (stock.dividend)
              ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("div", _hoisted_107, _toDisplayString(this.platformListOption[stock.platform_id]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_108, [
                        _createElementVNode("div", _hoisted_109, [
                          _createVNode(_component_v_data_table, {
                            headers: this.dividendGrid.headers,
                            items: stock.dividend,
                            "items-per-page-options": [10, 15, 20, 30, 50, 100, 200],
                            "items-per-page": 5,
                            class: "stock-data-table table text-start align-middle table-hover mb-0"
                          }, {
                            [`item.par_qty`]: _withCtx(({ item }) => [
                              _createElementVNode("span", null, _toDisplayString(this.$helper.formatPrice(item.amount / item.qty)), 1)
                            ]),
                            [`item.amount`]: _withCtx(({ item }) => [
                              _createElementVNode("span", null, _toDisplayString(this.$helper.formatPrice(item.amount)), 1)
                            ]),
                            [`item.created_at`]: _withCtx(({ item }) => [
                              _createElementVNode("span", null, _toDisplayString(this.$helper.formatDate(item.created_at, true)), 1)
                            ]),
                            _: 2
                          }, 1032, ["headers", "items"])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _cache[45] || (_cache[45] = _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "d-flex align-items-center ms-4 mt-4" }, [
            _createElementVNode("h4", { class: "flex-shrink-0" }, "Transaction")
          ])
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewStockPlatformWise, (stock, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `transaction-${index}`
          }, [
            (stock.transaction)
              ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("div", _hoisted_113, [
                        _createElementVNode("div", _hoisted_114, _toDisplayString(this.platformListOption[stock.platform_id]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("div", _hoisted_116, [
                          _createVNode(_component_v_data_table, {
                            headers: this.transactionGrid.headers,
                            items: stock.transaction,
                            "items-per-page-options": [10, 15, 20, 30, 50, 100, 200],
                            "items-per-page": 5,
                            class: "stock-data-table table text-start align-middle table-hover mb-0"
                          }, {
                            [`item.amount`]: _withCtx(({ item }) => [
                              _createElementVNode("span", null, _toDisplayString(this.$helper.formatPrice(item.amount)), 1)
                            ]),
                            [`item.sub_total`]: _withCtx(({ item }) => [
                              _createElementVNode("span", null, _toDisplayString(this.$helper.formatPrice(item.sub_total)), 1)
                            ]),
                            [`item.stock_avg_price`]: _withCtx(({ item }) => [
                              _createElementVNode("span", null, _toDisplayString(this.$helper.formatPrice(item.stock_avg_price)), 1)
                            ]),
                            [`item.p_l`]: _withCtx(({ item }) => [
                              (item.action == 2)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass((item.amount - item.stock_avg_price) * item.qty >= 0 ? 'text-success' : 'text-error')
                                  }, _toDisplayString(this.$helper.formatPrice(
                          (item.amount - item.stock_avg_price) * item.qty
                        )), 3))
                                : _createCommentVNode("", true)
                            ]),
                            [`item.created_at`]: _withCtx(({ item }) => [
                              _createElementVNode("span", null, _toDisplayString(this.$helper.formatDate(item.created_at, true)), 1)
                            ]),
                            _: 2
                          }, 1032, ["headers", "items"])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}